import { render, staticRenderFns } from "./estadisticasEliminacion.vue?vue&type=template&id=70a5302f&scoped=true&"
import script from "./estadisticasEliminacion.vue?vue&type=script&lang=js&"
export * from "./estadisticasEliminacion.vue?vue&type=script&lang=js&"
import style0 from "./estadisticasEliminacion.vue?vue&type=style&index=0&id=70a5302f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5302f",
  null
  
)

export default component.exports